﻿import { KbTextbox } from "@app/components/kb-textbox/kb-textbox.component";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";

@NgComponent({
    token: Token.KbTextarea,
    dependencies: [
        Token.$Timeout
    ]
})
export class KbTextarea extends KbTextbox {
    constructor($timeout: ng.ITimeoutService) {
        super($timeout);
        this.restrict = "E";
        this.replace = true;

        this.template = Dirs.component("kb-textarea");
    }
}
